






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {MotoristaTransbordo} from '@/model/resource/MotoristaTransbordo'
import {InputMotoristaTransbordoSchema} from '@/schema/resource/MotoristaTransbordo/InputMotoristaTransbordoSchema'

@Component
export default class PersistMotoristaTransbordoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputMotoristaTransbordoSchema()
  motoristaTransbordo = new MotoristaTransbordo()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionMotorista.listMotorista()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.motoristaTransbordo.getMotoristaTransbordo(id)
    }

    $.await.done('getMotoristaTransbordo')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.motoristaTransbordo.persistMotoristaTransbordo()
    await Helper.successAndPush(
      'system.success.persist',
      '/motorista-transbordo/list'
    )
  }
}
